export default (options) => {
  let content = '';

  if (options.other === true) {
    content = options.field2;
  } else if (options.other === false) {
    content = options.field1;
  }

  const checked = !(content === '' || !options.contributor);

  return {
    content,
    checked,
  };
};



// WEBPACK FOOTER //
// src/components/ContractBlock/Contents/Contribution.js